module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "MIMLogo.ea9454b3.svg";